import * as React from "react";
import { css } from "@emotion/core";
import {
  MaterialProperty,
  PieRow,
} from "../../../../../../smokepit/src/types/MaterialVolumes";

interface PieTooltipProps {
  active?: boolean;
  payload?: any[];
  propertyLabel: string;
  pieData: PieRow[];
  convertAndFormatPropertyValue: (
    volume: number,
    prop: MaterialProperty
  ) => string;
  brightMaterialColorMap: Map<number, string>;
}

export const PieTooltip: React.FC<PieTooltipProps> = ({
  active,
  payload,
  propertyLabel,
  pieData,
  convertAndFormatPropertyValue,
  brightMaterialColorMap,
}) => {
  if (active && payload && payload.length) {
    const data = payload[0];
    const materialId = data.payload?.material_id || data.material_id;
    const dataEntry = materialId
      ? pieData.find((entry) => entry.material_id === materialId)
      : pieData.find((entry) => entry.name === data.name);
    const formattedValue = dataEntry?.materialProperty
      ? convertAndFormatPropertyValue(data.value, dataEntry.materialProperty)
      : `${data.value.toLocaleString()}`;
    const total = pieData.reduce(
      (sum: number, item: PieRow) => sum + item.value,
      0
    );
    const percentage = total > 0 ? ((data.value / total) * 100).toFixed(1) : 0;
    const materialName = dataEntry?.name || data.name || "Unknown";
    return (
      <div
        css={css`
          background: var(--twilight);
          border: 1px solid var(--neutral-5);
          border-radius: 4px;
          padding: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          min-width: 200px;
        `}
      >
        <p
          css={css`
            margin: 0;
            font-weight: 600;
            color: ${materialId
              ? brightMaterialColorMap.get(materialId) || "var(--neutral-3)"
              : "var(--neutral-3)"};
            display: flex;
            justify-content: space-between;
            gap: 3rem;
          `}
        >
          <span>{materialName}</span>
          <span
            css={css`
              color: var(--neutral-3);
            `}
          >
            {percentage}%
          </span>
        </p>
        <p
          css={css`
            margin: 4px 0 0 0;
            color: var(--neutral-2);
            display: flex;
            justify-content: space-between;
          `}
        >
          <span>{propertyLabel}</span>
          <span
            style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}
          >
            {formattedValue}
          </span>
        </p>
      </div>
    );
  }
  return null;
};
